import React from 'react';
import { connect } from 'react-redux';
import { User } from '@ordermentum/ui-types';
import { Location } from '@ordermentum/ui-definitions';
import { SupplierRegisterV2 } from './SupplierRegisterV2';
import { RootState } from '../../redux/store';

export type Props = {
  location: Location;
  user: User;
};

export const SupplierRegister = (props: Props) => (
  <SupplierRegisterV2 {...props} />
);

const mapStateToProps = (state: RootState) => ({
  user: state?.profile?.data ?? {},
});

const SupplierRegisterConnected = connect(mapStateToProps)(SupplierRegister);

export { SupplierRegisterConnected };
